import { UntypedFormGroup } from '@angular/forms';
import { IDataService } from 'app/shared/services/data.service';
import { KeyValuePair } from 'app/shared/models/keyvaluepair';
import { map } from 'rxjs/operators';

// NOTE: properties: key = data property name, value = control name
export class ValidateUniqueCombination {
  static createValidator(service: IDataService, id: number|string, properties: KeyValuePair[]) {
    return (formGroup: UntypedFormGroup) => {
      if (properties.length > 0){
        const kvp: KeyValuePair[] = [];
        properties.forEach((i) => {
          const val = formGroup.get(i.value).value;
          if (val){
            kvp.push({
              key: i.key,
              value: val,
            });
          }
        });
        return service.isUniqueCombination(id, kvp).pipe(map((res) => {
          return res ? null : {notUniqueCombination: true};
        }));
      }
      else{
        return null;
      }
    };
  }
}
